import React from 'react';
import Select from "react-select";
import {getSelectorStyles} from "../multiSelectTableFilter/selectorStyles";
import {SelectOption} from "../select/SelectDropdown";

interface TableFilterDropdownProps<PROPERTY> {
    value?: PROPERTY;
    placeholder: string;
    width: number;
    handleChange: (v: PROPERTY | undefined) => any;
    options: SelectOption<PROPERTY>[];
    isClearable?: boolean;
}

export const TableFilterDropdown = <PROPERTY,>({
                                               value,
                                               placeholder,
                                               width,
                                               handleChange,
                                               options,
                                               isClearable = true
                                           }: TableFilterDropdownProps<PROPERTY>) => {

    const getSelectOptionByValue = () => {
        return options.find(o => o.value === value) || null;
    };

    return <Select
        isClearable={isClearable}
        placeholder={placeholder}
        value={getSelectOptionByValue()}
        onChange={selected => {
            handleChange(selected?.value);
        }}
        options={options}
        styles={getSelectorStyles(width)}
    />
}
